// skipcq: JS-W1028
import PropTypes from 'prop-types';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import { rawValueCaption, snapshotBeerStatus } from '../../utils/brewery/beerIngestionSnapshot';
import {
  SnapshotAbvCell,
  SnapshotDescriptionCell,
  SnapshotFieldCell,
  SnapshotIssuesCell,
  SnapshotStatusChip,
  SnapshotStyleCell,
} from './snapshotBeerTableCells';

function rowBackground(status) {
  if (status === 'invalid') {
    return 'error.light';
  }
  if (status === 'flagged') {
    return 'warning.light';
  }
  return undefined;
}

export default function SnapshotBeerRow({ beer }) {
  const status = snapshotBeerStatus(beer);
  const name = beer?.normalized?.name;

  return (
    <TableRow sx={{ bgcolor: rowBackground(status) }}>
      <TableCell>
        <SnapshotStatusChip beer={beer} />
      </TableCell>
      <SnapshotFieldCell
        displayValue={name}
        caption={rawValueCaption(beer?.raw?.name, name)}
      />
      <SnapshotStyleCell beer={beer} />
      <SnapshotAbvCell beer={beer} />
      <SnapshotDescriptionCell description={beer?.normalized?.description} />
      <SnapshotIssuesCell beer={beer} />
    </TableRow>
  );
}

SnapshotBeerRow.propTypes = {
  beer: PropTypes.object.isRequired,
};
